import axios from "axios"
import Cookies from 'js-cookie'

const access_token = Cookies.get("accessToken");

axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

export const GET = (url = "", config = {}) => axios.get(url, config);
